export const generateAnalyticsTable = (companyInfo, companyData) => {
    let arr = [], tempArr = [];
    arr = Object.keys(companyData).map(companyId => {
        tempArr = [];
        let val1 = valueSanitization(companyData[companyId].overview['completedDeliveries'], false);
        let val2 = inMinutes(valueSanitization(companyData[companyId].overview['avgPickupToDeliveryTime']));
        let val3 = valueSanitization(companyData[companyId].overview['onTimeDeliveries']);
        let val4 = inMinutes(valueSanitization(companyData[companyId].overview['avgPlacementToDeliveryTime']));
        tempArr.push(companyInfo[companyId].companyName, val1, val3, val2, val4);
        return tempArr;
    })

    return arr;
}

function inMinutes(val) {
    val = Number(val);
    if (val === -1 || isNaN(val) || val === undefined) val = 'N/A';
    else val = Math.round(val) + " min";
    return val;
}

function valueSanitization(val, isFloat = true) {
    if (val === -1 || isNaN(val) || val === undefined) val = 'N/A';
    else if (isFloat) val = Number(val).toFixed(2);
    return val;
}

export function typeMapper(selectedType) {
    switch (selectedType) {
        case "pickupToDeliveryTime":
            return "avgPickupToDeliveryTime";
        case "placementToDeliveryTime":
            return "avgPlacementToDeliveryTime";
        default:
            return selectedType;
    }
}
